import { render, staticRenderFns } from "./localUserSend.vue?vue&type=template&id=1cb92d2d&scoped=true&"
import script from "./localUserSend.vue?vue&type=script&lang=js&"
export * from "./localUserSend.vue?vue&type=script&lang=js&"
import style0 from "./localUserSend.vue?vue&type=style&index=0&id=1cb92d2d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb92d2d",
  null
  
)

export default component.exports